import type { FaireProductEntity } from "../../entity_types/product";

export const p_4y5vbx4w5v: FaireProductEntity = {
  token: "p_4y5vbx4w5v",
  type: "product",
  name: "Jasper Fancy Crystal Spheres",
  brandToken: "b_eqykpyrhjx",
  brandName: "The Healing Sanctuary",
  imageUrl:
    "https://cdn.faire.com/fastly/7f8cbca6db1e83af58e5c9b7d800c6cd02ac825e1b084a307e2796e26b7d7500.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5a3222c028e9106ca80e2ff6d76fc7c20864c7d97e4defd3cb4736e263db649.jpeg",
  ],
  priceDollars: 43,
  description:
    "You will receive 1/2 pound mix of spheres. (15-25mm)(@20-25 spheres)\n\nSpiritually fancy Jasper helps to ground and organize the mind and assists one in finding resolution for mundane problems. It can help one to be more linear in one's approach to life.\n\nEmotionally this variety of Jasper helps calm fear or worry, especially when it is caused by an overactive but unfocused mind. It can prevent one from being caught up in the future or the past and assists in focusing on working through the issues of the present.\n\nAffirmation: Day by day, I improve my health and well-being, my organization and efficiency and I handle problems immediately as they arise\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n\n*Each and every crystal shipped from us is blessed with Reiki Love.",
  tags: [],
  msrpDollars: 86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:33.877Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
